import MetaTags from '@/components/seo/meta-tags';
import FeatureImageWithBlur from '@/components/us-website/FeatureImageWithBlur/FeatureImageWithBlur';
import StatutoryDisclosures from '@/components/us-website/StatutoryDisclosures/StatutoryDisclosures';
import { getCDNImageUrl } from '@/utils/Common';
import React from 'react';

function StatutoryDisclosuresPage() {
  return (
    <>
      <MetaTags
        title="Statutory Disclosures - Elchemy"
        description="Statutory disclosures and documents as required under the Companies Act, 2013 and Rules made thereunder."
        includeAlternateLink={false}
      />
      <div className="overflow-hidden">
        {/* Banner Section */}
        <FeatureImageWithBlur
          heading="Statutory Disclosures"
          description="As required under the Companies Act, 2013 and Rules made thereunder."
          imageSrc={getCDNImageUrl("Statutory_Banner_Image.webp")}
          variant="dark"
          showPrimaryButton={false}
          showSecondaryButton={false}
        />

        {/* Statutory Disclosures and Documents Section */}
        <StatutoryDisclosures />
      </div>
    </>
  );
}

export default StatutoryDisclosuresPage;
